import React from 'react';
import { Footer, FooterText } from './style';

export default function FooterComp() {
  const curYear = new Date().getFullYear();
  return (
    <Footer>
      <FooterText>Copyright © {curYear} Conviva. All rights reserved.</FooterText>
    </Footer>
  );
}
